import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-checkbox",
  templateUrl: "./med-icon-checkbox.component.html",
})
export class MedIconCheckboxComponent extends SvgMixinComponent {}
